import { GetterTree } from "vuex";
import { ScoreState } from "../types";
import { IRootState } from "../../types";

import {
  getCaloriesAsBurgers,
  getUnitsAsSpirits,
  getUnitsAsBeers
} from "@dcc/score/conversions";
import { IScoreGetters } from "./types";
import { GetterNames } from "./names";

export const getters: GetterTree<ScoreState, IRootState> = {
  [GetterNames.WEEKLYCALORIESASBURGERS](
    state: ScoreState,
    getters: IScoreGetters
  ): number {
    const weeklyUnitsAndCalories = getters[GetterNames.WEEKLYUNITSANDCALORIES];
    return getCaloriesAsBurgers(weeklyUnitsAndCalories.calories);
  },
  [GetterNames.WEEKLYUNITSASSPIRITS](
    state: ScoreState,
    getters: IScoreGetters
  ): number {
    const weeklyUnitsAndCalories = getters[GetterNames.WEEKLYUNITSANDCALORIES];
    return getUnitsAsSpirits(weeklyUnitsAndCalories.units);
  },
  [GetterNames.WEEKLYUNITSASBEERS](
    state: ScoreState,
    getters: IScoreGetters
  ): number {
    const weeklyUnitsAndCalories = getters[GetterNames.WEEKLYUNITSANDCALORIES];
    return getUnitsAsBeers(weeklyUnitsAndCalories.units);
  }
};
